import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("copyquick-pod") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App
      printingOption={rootElement.dataset.printingOption ?? ""}
      productId={parseInt(rootElement.dataset.productId ?? "0")}
      isSchoolUser={rootElement.dataset.isSchoolUser === "true" ? true : false}
      wpNonce={rootElement.dataset.wpnonce ?? ""}
    />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
